'use strict';
angular.module('atex.dam').factory("DrawerService", [function() {

  var svc = {};
  
  svc.items = [];
  svc.collection = {};

  function DrawerService( ) {
  }
  
  DrawerService.getItems = function() {
    return svc.items;
  };
  
  DrawerService.setItems = function(newItems) {
    angular.copy(newItems, svc.items);
  };
  
  DrawerService.clearItems = function()  {
    svc.items.length = 0;
  };
  
  DrawerService.contains = function(contentId) {
    var index = svc.items.ArrayIndexOf(function(entry) {
      return !!entry && entry.id === contentId;
    });
    if (index>=0) {
      return true;
    }
    return false;
  };
  
  DrawerService.canCollectType = function(inputTemplate) {
    if (inputTemplate.startsWith("p.Collection")) {
      return false;
    }
    return true;
  };
  
  DrawerService.getCollection = function() {
    return svc.collection;
  };
  
  DrawerService.setCollection = function(collection) {
    angular.copy(collection, svc.collection);
  };
  
  DrawerService.clearCollection = function()  {
    angular.copy({}, svc.collection);
  };
  
  DrawerService.isCurrentCollection = function(collection) {
    if (svc.collection.id && svc.collection.id === collection.id) {
      return true;
    }
    return false;
  };
  
  DrawerService.clear = function() {
    DrawerService.clearCollection();
    DrawerService.clearItems();
  };
  
  DrawerService.prototype = {
    constructor: DrawerService
  };
   
  return(DrawerService);
}]);
